export class ConfigUtil {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static get(key: string): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config = (window as any).APP_CONFIG || {};
    return config[key] ?? null;
  }
}
